<template>
    <div class="products-container">
        <div class="product-container" v-for="product in products" :key="product.serial">
            <div @click="productSelected(product)" class="product">
                <div style="height: 100%;background-size: cover;background-position: center;background-repeat: no-repeat;" :style="{'background-image': `url(${product.thumbnail})`}"></div>
                <div class="description">
                    <p>{{ product.display_name }}</p>
                </div>
                <checkbox style="position: absolute;right: 16px;top: 16px;" :value="value && (value.serial === product.serial)" />
            </div>
        </div>
        <div class="product-container" v-if="hasNext">
            <div @click="getProducts" class="product">
                Load More...
            </div>
        </div>
    </div>
</template>

<script>
import { products } from '@/api'
import _ from 'lodash'

export default {
    props: {
        value: {
            type: Object,
            default: () => {}
        }
    }, 
    data() {
        return {
            products: [],
            hasNext: false,
            next: null,
            loading: false
        }
    },
    mounted() {
        this.getProducts()
    },
    methods: {
        productSelected(product) {
            this.$emit('input', _.cloneDeep(product))
        },
        getProducts() {
            this.$store.dispatch('load', products.get(this.next).then((response) => {
                this.products = [...this.products, ...response.data.results]
                this.hasNext = response.data.next ? true : false
                this.next = response.data.next
            }))
        }
    }
}
</script>

<style scoped>
.products-container {
    overflow-y: auto;
    flex: 1;
    max-height: 330px;
}

.product-container {
    width: 33%;
    display: inline-block;
    vertical-align: top;
}

.product-container .product {
    border: 1px solid #ECEEF4;
    margin: 8px;
    height: 120px;
    position: relative;

    overflow: hidden;
    border: 1px solid lightgrey;
}

.product-container .product .description {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    padding: 12px;
    padding-top: 20px;

    background-image: linear-gradient(to top,rgba(0,0,0,.65) 0,rgba(0,0,0,.5525) 55%,rgba(0,0,0,.195) 85%,rgba(0,0,0,0) 100%);
}

.product-container .product .description p {
    font-size: 13px;
    color: white;
}

.product-container .product .description p:not(:last-child) {
    margin-bottom: 4px;
}



.product-container .product:hover {
    cursor: pointer;
}

.product-container .product.button {
    display: flex;
    align-items: center;
    justify-content: center;
}

.product-container .product.button p {
    font-weight: bold;
    font-size: 20px;
}

.product-container .product p {
    margin-bottom: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
}

@media screen and (max-width: 512px) {
    .product-container {
        width: 50%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ProductSelect.vue